import * as React from 'react';
import { Trans } from 'react-i18next';
import s from '../../Cycles/Cycles.scss';
import classNames from 'classnames';
import { PaymentCycle } from 'enums';
import { Text } from '@wix/design-system';

export interface ResellerDiscountBadgeProps {
  isCycleSelected: boolean;
  discount: number;
  cycleId: PaymentCycle;
}

const ResellerDiscountBadgeContent: React.FC<{
  isCycleSelected: boolean;
  discount: number;
}> = ({ discount, isCycleSelected }) => {
  const discountBadgeClassNames = classNames(s.discountBadge, s.green, {
    [s.cycleSelected]: isCycleSelected,
  });
  return (
    <div className={discountBadgeClassNames}>
      <Text
        size='small'
        weight='bold'
        className={s.badgeText}
        light={isCycleSelected}
        skin={isCycleSelected ? 'standard' : 'success'}
        dataHook='reseller-discount-badge'
      >
        <Trans
          i18nKey='cycle_entry.cycle_discount'
          values={{ discount: `${discount}%` }}
        >
          part1 <span> part2</span>
        </Trans>
      </Text>
    </div>
  );
};

export const ResellerDiscountBadge: React.FunctionComponent<
  ResellerDiscountBadgeProps
> = ({ isCycleSelected, discount }) => {
  return (
    <ResellerDiscountBadgeContent
      isCycleSelected={isCycleSelected}
      discount={discount}
    />
  );
};
